import { isSidNotificationType } from "../../../lib/notifications/sidNotificationTypes";

export const getNotificationsTabs = state =>
  state.newNotifications.notificationsTabs;

export const getSelectedTabName = state => state.newNotifications.selectedTabName;

export const getSelectedNotificationsTab = state => {
  const notificationsTabs = getNotificationsTabs(state);
  const selectedTabName = getSelectedTabName(state);

  return (
    notificationsTabs.find(({ name }) => name === selectedTabName) ||
    notificationsTabs[0]
  );
};

export const getFilters = state => {
  return state.newNotifications.filters;
};

export const getUnreadCount = state => {
  return state.newNotifications.notificationsTabs[0].unreadCount;
};

export const getLoading = state => {
  return state.newNotifications.notificationsTabs[0].loading;
};

export const getGlobalLoading = state => {
  return state.newNotifications.globalLoading;
};

let memoizedNotificationTypesSource = null;
let memoizedNotificationTypesFilters = {};

export const getNotificationTypesFilters = state => {
  const sourceFilters = state.newNotifications.filters;

  if (memoizedNotificationTypesSource === sourceFilters) {
    return memoizedNotificationTypesFilters;
  }

  const filters = {};

  for (const [name, filter] of Object.entries(sourceFilters)) {
    if (filter.type !== "checkbox") {
      continue;
    }

    filters[name] = filter;
  }

  memoizedNotificationTypesSource = sourceFilters;
  memoizedNotificationTypesFilters = filters;

  return filters;
};

export const getInitialFetchComplete = state =>
  state.newNotifications.initialFetchComplete;

export const getAllTabNotifications = state =>
  state.newNotifications.notificationsTabs[0]?.notifications ?? [];

export const getLatestSidNotificationFromAllTab = state => {
  const notifications = getAllTabNotifications(state);

  return notifications.find(({ notification_type }) =>
    isSidNotificationType(notification_type)
  );
};

export const getLatestNotificationFromAllTabMatchingTypes = (
  state,
  notificationTypes = []
) => {
  if (!notificationTypes.length) {
    return undefined;
  }

  const notifications = getAllTabNotifications(state);

  return notifications.find(({ notification_type }) =>
    notificationTypes.includes(notification_type)
  );
};
